import React from "react";
import Admin from "us.collection.admin";

const Cnt_NonProductionDaysCalendar: React.FC = (props) => {
  return <Admin.Components.NonProductionDays.Calendar {...props} />;
};

export default Cnt_NonProductionDaysCalendar;
